import React, { Component, Fragment } from 'react';
import withErrorCatcher from '../../components/Common/withErrorCatcher.js'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { Button, Menu, MenuItem, Select, withStyles } from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import SettingsDrawer from '../../components/App/Drawers/settingsDrawer';
import AppContent from '../../components/App/appContent';
import PageContentWrapper from '../../components/App/PageComponents/pageContentWrapper';
import Divider from '@material-ui/core/Divider';
import Switch from '@material-ui/core/Switch';
import { showSnackbar } from '../../../actions/appActions'
import { withTranslation } from 'react-i18next';
import { useState } from 'react';

const Setting = withTranslation('notificationSettings')((props) => {

    const { settingsFunction, primary, secondary, title, divider, t } = props
    const { saveChange, isChecked, disabledButtons, getRule, saveHandlerChange } = settingsFunction
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const updateHandlerSetting = (settingNumber) => {
        let handlerSetting = {
            emailHandler: false,
            mobileHandler: false
        };

        if (settingNumber === 1) {
            saveChange(title, true)
            handlerSetting = {
                emailHandler: true,
                mobileHandler: true
            }
        }

        if (settingNumber === 2) {
            saveChange(title, true)
            handlerSetting = {
                emailHandler: false,
                mobileHandler: true
            }
        }
        if (settingNumber === 3) {
            saveChange(title, true)
            handlerSetting = {
                emailHandler: true,
                mobileHandler: false
            }
        }

        if (settingNumber === 0) {

            saveChange(title, false)

            handlerSetting = {
                emailHandler: false,
                mobileHandler: false
            }
        }

        saveHandlerChange(title, handlerSetting)
        setAnchorEl(null);

    }

    // const getCurrentState = () => {
    //     const rule = getRule(title)

    //     if (!rule) {
    //         return 'None'
    //     }

    //     if (rule.emailHandler && rule.mobileHandler) {
    //         return 'Mobile and Mail'
    //     } else if (rule.emailHandler && !rule.mobileHandler) {
    //         return 'Mail'
    //     } else if (!rule.emailHandler && rule.mobileHandler) {
    //         return 'Mobile'
    //     } else {
    //         return 'None'
    //     }
    // }

    const getCurrentState = () => {
        const rule = getRule(title)

        if (!rule) {
            return 0
        }

        if (rule.emailHandler && rule.mobileHandler) {
            return 1
        } else if (rule.emailHandler && !rule.mobileHandler) {
            return 3
        } else if (!rule.emailHandler && rule.mobileHandler) {
            return 2
        } else {
            return 0
        }
    }

    const defaultDescription = title.split('.').join(' ')



    return (
        <Fragment>
            <ListItem>
                {/* <Button
                    size={"small"}
                    aria-owns={anchorEl ? 'simple-menu' : undefined}
                    aria-haspopup="true"
                    onClick={handleClick}
                >
                    {getCurrentState()}
                </Button> */}

                <ListItemText primary={t(primary || defaultDescription)}
                    secondary={t(secondary) || ''} />
                <ListItemSecondaryAction>
                    <Select
                        id="simple-menu"
                        style={{ width: 100 }}
                        onChange={(event) => { updateHandlerSetting(event.target.value) }}
                        value={getCurrentState()}
                    >
                        <MenuItem value={1} >{t("Both")}</MenuItem>
                        <MenuItem value={2} >{t("Mobile")}</MenuItem>
                        <MenuItem value={3} >{t("Mail")}</MenuItem>
                        <MenuItem value={0} >{t("None")}</MenuItem>
                    </Select>
                </ListItemSecondaryAction>

            </ListItem>
            {divider ? <Divider /> : null}
        </Fragment>
    )
})
const styles = theme => ({
    paperStyle: {
        marginBottom: 40,
    }
})


class Notifications extends Component {

    state = {
        disabledButtons: []
    }

    isChecked = (title) => {
        let rule = this.props.userData.notificationRules.find(r => r.title === title)
        return rule && rule.isActive
    }

    getRule = (title) => {
        let rule = this.props.userData.notificationRules.find(r => r.title === title)
        return rule
    }


    saveChange = (title, ruleState) => {
        const { userData, notificationService, dispatch, t } = this.props;

        // this.setState({ disabledButtons: [...this.state.disabledButtons, title] })
        let rule = userData.notificationRules.find(r => r.title === title)
        if (rule) {
            rule.isActive = ruleState
        }

        notificationService.activateRule(rule.id, ruleState)
            .then((res) => {
                // this.state.disabledButtons.splice(this.state.disabledButtons.indexOf(title), 1)
                // this.setState({ disabledButtons: [...this.state.disabledButtons] })

                // dispatch({ type: 'USER_PROFILE_UPDATE', profileData: { notificationRules: [...userData.notificationRules] } });
                // dispatch(showSnackbar(t('Saved!')));
            })
    }

    saveHandlerChange = (title, handlerSettings) => {
        const { userData, notificationService, dispatch, t } = this.props;

        this.setState({ disabledButtons: [...this.state.disabledButtons, title] })
        let rule = userData.notificationRules.find(r => r.title === title)
        if (rule) {
            rule.emailHandler = handlerSettings.emailHandler
            rule.mobileHandler = handlerSettings.mobileHandler
        }
        this.props.dispatch(showSnackbar(t('Saving')));

        notificationService.updateRuleHandler(rule.id, handlerSettings)
            .then((res) => {
                this.state.disabledButtons.splice(this.state.disabledButtons.indexOf(title), 1)
                this.setState({ disabledButtons: [...this.state.disabledButtons] })

                dispatch({ type: 'USER_PROFILE_UPDATE', profileData: { notificationRules: [...userData.notificationRules] } });
                dispatch(showSnackbar(t('Saved!')));
            })
    }

    settingsFunction = {
        saveChange: this.saveChange,
        isChecked: this.isChecked,
        getRule: this.getRule,
        saveHandlerChange: this.saveHandlerChange,
        disabledButtons: this.state.disabledButtons
    }

    render() {
        const { classes, userData, dispatch, t } = this.props;

        return (
            <AppContent>
                <PageContentWrapper drawer={<SettingsDrawer selected="notifications" />}>
                    <Grid spacing={16}>

                        <Typography variant="title" style={{ marginBottom: '15px' }}>
                            {t('Manage notifications')}
                        </Typography>



                        <Typography variant="body2" gutterBottom>
                            {t('Notifications For item that I created')}
                        </Typography>
                        <Paper className={classes.paperStyle}>
                            <List className={classes.listStyle}>
                                <Setting primary='Comment about my item'
                                    secondary='Turn notifications on / off for comments that users make about an item that I created'
                                    title={'Author.Comment.Create'}
                                    settingsFunction={this.settingsFunction}
                                    divider={true}
                                />
                                <Setting primary='My Item is seen by anyone'
                                    secondary='Turn notifications on / off for item that has been seen by any other user in the system'
                                    title={'Author.Seen.One'}
                                    settingsFunction={this.settingsFunction}
                                    divider={true}
                                />
                                <Setting primary='My Item is seen by all users'
                                    secondary='Turn notifications on / off for item that has been seen by any other user in the system'
                                    title={'Author.Seen.All'}
                                    settingsFunction={this.settingsFunction}
                                    divider={true}
                                />
                                <Setting
                                    primary='New task on my item'
                                    secondary='Turn notifications on / off when new task create on my item'
                                    title={'Author.Task.Create'}
                                    settingsFunction={this.settingsFunction}
                                    divider={true}
                                />
                                <Setting
                                    primary='Task on my item is finished'
                                    secondary='Turn notifications on / off when task on my item is finished'
                                    title={'Author.Task.Done'}
                                    settingsFunction={this.settingsFunction}
                                    divider={true}
                                />
                                <Setting
                                    primary='Linked item added to my item'
                                    secondary='Turn notifications on / off when linked item added to my item'
                                    title={'Author.Linked.Create'}
                                    settingsFunction={this.settingsFunction}
                                    divider={true}
                                />
                                <Setting
                                    primary='Member added to my item'
                                    secondary='Turn notifications on / off when member added to my item'
                                    title={'Author.Member.Add'}
                                    settingsFunction={this.settingsFunction}
                                    divider={false}
                                />
                                <Setting
                                    primary='My Item edited By another member'
                                    secondary='Turn notifications on / off when member added to my item'
                                    title={'Author.Item.Edit'}
                                    settingsFunction={this.settingsFunction}
                                    divider={false}
                                />
                                <Setting
                                    primary='User confirmed reading an item that you assigned him'
                                    secondary='Turn notifications on / off when user confirmed reading an item that you assigned him'
                                    // title={'Author.Read.One'}
                                    title={'Author.Item.Read'}
                                    settingsFunction={this.settingsFunction}
                                    divider={false}
                                />
                                <Setting
                                    primary='All users confirmed reading the item that you assigned them to'
                                    secondary='Turn notifications on / off when all users confirmed reading the item that you assigned them to'
                                    title={'Author.Read.All'}
                                    settingsFunction={this.settingsFunction}
                                    divider={true}
                                />
                                <Setting
                                    primary='Due date notifications that were setup on your items'
                                    secondary='Turn notifications on / off when due date is approaches'
                                    title={'Author.Item.DueDate'}
                                    settingsFunction={this.settingsFunction}
                                    divider={false}
                                />


                            </List>
                        </Paper>

                        <Typography variant="body2" gutterBottom>
                            {t('Notifications For Subscribed Channels')}
                        </Typography>
                        <Paper className={classes.paperStyle}>
                            <List className={classes.listStyle}>

                                <Setting
                                    primary='Comment about items under subscribed channel'
                                    secondary='Turn notifications on/off that when somebody comments about an item that includes the channel that I subscribed to'
                                    title={'SubscribeTag.Comment.Create'}
                                    settingsFunction={this.settingsFunction}
                                    divider={true}
                                />

                                <Setting
                                    primary='Notification about an item that created under a subscribed channel'
                                    // secondary='Turn notifications on/off that when somebody created under a subscribed channel'
                                    title={'SubscribeTag.Create'}
                                    settingsFunction={this.settingsFunction}
                                    divider={true}
                                />
                                <Setting
                                    // primary='Author.Task.Done'
                                    // secondary='Turn notifications on / off for item that has been seen by any other user in the system'
                                    title={'SubscribeTag.Edit'}
                                    settingsFunction={this.settingsFunction}
                                    divider={true}
                                />

                                <Setting
                                    // primary='Author.Task.Done'
                                    // secondary='Turn notifications on / off for item that has been seen by any other user in the system'
                                    title={'SubscribeTag.Task.Create'}
                                    settingsFunction={this.settingsFunction}
                                    divider={false}

                                />

                                {/* <Setting
                                    title={'SubscribeTag.Task.Done'}
                                    settingsFunction={this.settingsFunction}
                                    divider={false}
                                /> */}

                            </List>
                        </Paper>

                        <Typography variant="body2" gutterBottom>
                            {t('Notifications For Mention')}
                        </Typography>
                        <Paper className={classes.paperStyle}>
                            <List className={classes.listStyle}>

                                <Setting
                                    primary='Comments about items with my name'
                                    secondary='Turn notifications on/off when somebody Comments about an item that includes my name'
                                    title={'Mention.Comment.Create'}
                                    settingsFunction={this.settingsFunction}
                                    divider={true}
                                />

                                <Setting
                                    primary='Notification about an item that created with my name'
                                    secondary='Turn notifications on / off when an item is created with my name'
                                    title={'Mention.Create'}
                                    settingsFunction={this.settingsFunction}
                                    divider={true}
                                />
                                <Setting
                                    // primary='Author.Task.Done'
                                    // secondary='Turn notifications on / off for item that has been seen by any other user in the system'
                                    title={'Mention.Edit'}
                                    settingsFunction={this.settingsFunction}
                                    divider={true}
                                />

                                <Setting
                                    primary='Task is assigned to me'
                                    secondary='Turn notifications on / off when a task is assigned to me'
                                    title={'Mention.Task.Create'}
                                    settingsFunction={this.settingsFunction}
                                    divider={true}
                                />

                                <Setting
                                    primary='My task is finished'
                                    secondary='Turn notifications on / off when my task is finished'
                                    title={'Mention.Task.Done'}
                                    settingsFunction={this.settingsFunction}
                                    divider={true}
                                />
                                <Setting
                                    primary='I added to an item as a member'
                                    title={'Mention.Member.Add'}
                                    settingsFunction={this.settingsFunction}
                                    divider={true}
                                />
                                <Setting
                                    primary='I added to a group as a member'
                                    title={'Mention.Group.Add'}
                                    settingsFunction={this.settingsFunction}
                                    divider={false}

                                />





                            </List>
                        </Paper>
                        <Typography variant="body2" gutterBottom>
                            {t('Notifications For Item That I Commented On')}
                        </Typography>
                        <Paper className={classes.paperStyle}>
                            <List className={classes.listStyle}>

                                <Setting
                                    primary='Comment on an item'
                                    secondary='Turn notifications on / off for comments that users made about this item'
                                    title={'SubscribeItem.Comment.Create'}
                                    settingsFunction={this.settingsFunction}
                                    divider={true}
                                />

                                {/* <Setting
                                     primary='Author.Task.Done'
                                     secondary='Turn notifications on / off for item that has been seen by any other user in the system'
                                    title={'SubscribeItem.Create'}
                                    settingsFunction={this.settingsFunction}
                                    divider={true}
                                /> */}

                                <Setting
                                    // primary='Author.Task.Done'
                                    // secondary='Turn notifications on / off for item that has been seen by any other user in the system'
                                    title={'SubscribeItem.Edit'}
                                    settingsFunction={this.settingsFunction}
                                    divider={true}
                                />


                                <Setting
                                    primary='Task created for the item'
                                    secondary='Turn notifications on / off when a new task created for the item'
                                    title={'SubscribeItem.Task.Create'}
                                    settingsFunction={this.settingsFunction}
                                    divider={true}
                                />


                                <Setting
                                    primary='Task finished for the item'
                                    secondary='Turn notifications on / off when a task is finished for the item'
                                    title={'SubscribeItem.Task.Done'}
                                    settingsFunction={this.settingsFunction}
                                    divider={true}
                                />

                                <Setting
                                    primary='All users Seen the item'
                                    secondary='Turn notifications on/off when this item is seen by any other user in the system'
                                    title={'SubscribeItem.Seen.All'}
                                    settingsFunction={this.settingsFunction}
                                    divider={true}
                                />

                                <Setting
                                    primary='Anyone Seen this item'
                                    secondary='Turn notifications on/off when this item is seen by all the user in the system'
                                    title={'SubscribeItem.Seen.One'}
                                    settingsFunction={this.settingsFunction}
                                    divider={true}
                                />

                                <Setting
                                    primary='Linked item added to an item'
                                    secondary='Turn notifications on / off when Linked item added to an item'
                                    title={'SubscribeItem.Linked.Create'}
                                    settingsFunction={this.settingsFunction}
                                    divider={false}
                                />
                            </List>
                        </Paper>

                        <Typography variant="body2" gutterBottom>
                            {t('Notifications For Item In My Group')}
                        </Typography>
                        <Paper className={classes.paperStyle}>
                            <List className={classes.listStyle}>
                                <Setting
                                    primary='Comment about items under the group'
                                    secondary=""
                                    title={'Group.Comment.Create'}
                                    settingsFunction={this.settingsFunction}
                                    divider={true}
                                />

                                <Setting
                                    primary='Item created in a group'
                                    secondary="Turn notifications on/off when Item created in a group that I'm a member at"
                                    title={'Group.Create'}
                                    settingsFunction={this.settingsFunction}
                                    divider={true}
                                />
                                <Setting
                                    primary='Item edited in a group'
                                    secondary='Turn notifications on/off when item edited in a group'
                                    title={'Group.Edit'}
                                    settingsFunction={this.settingsFunction}
                                    divider={true}
                                />

                                <Setting
                                    primary='Task added to an item in the group'
                                    secondary="Turn notifications on/off when task added to an item in a group that I'm a member at"
                                    title={'Group.Task.Create'}
                                    settingsFunction={this.settingsFunction}
                                    divider={true}
                                />

                                <Setting
                                    primary='Task finished in the group'
                                    // secondary='Turn notifications on / off for item that has been seen by any other user in the system'
                                    title={'Group.Task.Done'}
                                    settingsFunction={this.settingsFunction}
                                    divider={true}
                                />

                                <Setting
                                    primary='Item in the group has been linked'
                                    // secondary='Turn notifications on / off for item that has been seen by any other user in the system'
                                    title={'Group.Linked.Create'}
                                    settingsFunction={this.settingsFunction}
                                    divider={true}
                                />

                                <Setting
                                    primary='New user has been added to the group'
                                    // secondary='Turn notifications on / off for item that has been seen by any other user in the system'
                                    title={'Group.Member.Add'}
                                    settingsFunction={this.settingsFunction}
                                    divider={true}
                                />

                                <Setting
                                    primary='Item moved from lane'
                                    // secondary='Turn notifications on / off for item that has been seen by any other user in the system'
                                    title={'Group.MoveItem.Lane'}
                                    settingsFunction={this.settingsFunction}
                                    divider={false}
                                />

                            </List>
                        </Paper>

                        <Typography variant="body2" gutterBottom>
                            {t('Notifications For Calendar or Tasks')}
                        </Typography>
                        <Paper className={classes.paperStyle}>
                            <List className={classes.listStyle}>
                            <Setting
                                    primary='Item that related to calendar event'
                                    secondary='Turn notifications on/off when Tuqqi find items that relevant to my event'
                                    title={'Calendar.Event.Create'}
                                    settingsFunction={this.settingsFunction}
                                    divider={true}
                                />
                                <Setting
                                    primary='Item that related to calendar event'
                                    secondary='Turn notifications on/off when Tuqqi find items that relevant to my event'
                                    title={'Calendar.Event.Create'}
                                    settingsFunction={this.settingsFunction}
                                    divider={false}
                                />
                            </List>
                        </Paper>

                        <Typography variant="body2" gutterBottom>
                            {t('Notifications For Scoreboard')}
                        </Typography>
                        <Paper className={classes.paperStyle}>
                            <List className={classes.listStyle}>
                                <Setting
                                    primary='Notify me when a user reached a new level'
                                    secondary='Coming soon'
                                    title={'Scoreboard.Level.Degree'}
                                    settingsFunction={this.settingsFunction}
                                    divider={false}
                                />
                            </List>
                        </Paper>
                    </Grid>
                </PageContentWrapper>
            </AppContent >
        )
    }
}

const mapStateToProps = (state) => ({
    ...state.services,
    globalData: state.globalData,
    userData: state.userData,
})

const mapDispatchToProps = dispatch => {
    return {
        dispatch: dispatch
    }
}

export default compose(withStyles(styles),
    withTranslation('notificationSettings'),
    connect(
        mapStateToProps,
        mapDispatchToProps
    ))(Notifications);
